export default __webpack_public_path__ + "static/media/AnimalPage1.429db389.txt";